// src/components/common/EthPrice.js
import React, { useState, useEffect, useRef } from 'react';
import web3service from '../../services/web3service';
import Logger from '../../utils/logger-adapter';

const EthPrice = () => {
    // États pour gérer le prix et l'état de chargement
    const [price, setPrice] = useState("");
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const fetchingRef = useRef(false);
    const cacheTimeRef = useRef(0);
    const cachedPriceRef = useRef(null);
    
    useEffect(() => {
        let isMounted = true;
        
        const fetchPrice = async () => {
            // Utiliser le cache si moins de 60 secondes
            const now = Date.now();
            if (now - cacheTimeRef.current < 60000 && cachedPriceRef.current) {
                if (isMounted && isFirstLoad) {
                    setPrice(cachedPriceRef.current);
                    setIsFirstLoad(false);
                }
                return;
            }
            
            // Éviter les appels concurrents
            if (fetchingRef.current) return;
            
            try {
                fetchingRef.current = true;
                
                // Utiliser directement la fonction existante du service
                const ethPrice = await web3service._getEthPrice();
                
                if (isMounted) {
                    // Format avec 2 décimales
                    const formattedPrice = ethPrice.toFixed(2);
                    setPrice(formattedPrice);
                    setIsFirstLoad(false);
                    
                    // Mise à jour du cache
                    cachedPriceRef.current = formattedPrice;
                    cacheTimeRef.current = now;
                }
            } catch (error) {
                console.error('Error fetching ETH price:', error);
                Logger.error(error, { context: 'EthPrice' });
            } finally {
                fetchingRef.current = false;
            }
        };
        
        fetchPrice();
        
        // Utiliser le même intervalle de rafraîchissement que pour le reste du site
        const interval = setInterval(fetchPrice, 60000);
        
        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, [isFirstLoad]);
    
    // Affichage pendant le chargement
    if (isFirstLoad) {
        return <span className="price-display loading">Loading...</span>;
    }
    
    return (
        <span className="price-display">
            ${price}
        </span>
    );
};

export default React.memo(EthPrice);
